import api from "./api";

export const BASE_URL = "/api/_internal/openrouter/models/";

export type ModelArchitecture = {
  tokenizer: string;
  instruct_type: string | null;
  modality: string | null;
  input_modalities: string[];
  output_modalities: string[];
};

export type OpenRouterModel = {
  id: string;
  canonical_slug: string;
  provider: string;
  name: string;
  created: string; // ISO datetime string
  description: string;
  pricing: Record<string, unknown>;
  context_length: number | null;
  input_pricing: string; // DecimalField serializes as string
  output_pricing: string; // DecimalField serializes as string
  architecture: ModelArchitecture;
  supported_parameters: string[];
  default_parameters: Record<string, unknown>;
  last_synced_at: string; // ISO datetime string
  is_already_added?: boolean;
  tier: string;
};

export type ModelListParams = {
  search?: string;
  providers?: string[];
  supported_parameters?: string[];
  tiers?: string[];
  added_models?: string[];
};

export type FilterOptions = {
  providers: string[];
  supported_parameters: string[];
  tiers: [string, string][];
  addedModels: string[];
};

/**
 * List OpenRouter models with search and filtering
 */
export async function listModels(
  token: string,
  params: ModelListParams
): Promise<OpenRouterModel[]> {
  const response = await api.post<OpenRouterModel[]>(
    `${BASE_URL}list`,
    params,
    {
      headers: { token },
    }
  );
  return response.data;
}

/**
 * Get available filter options for providers and supported_parameters
 */
export async function getFilterOptions(token: string): Promise<FilterOptions> {
  const response = await api.get<FilterOptions>(`${BASE_URL}filter-options`, {
    headers: { token },
  });
  return response.data;
}

/**
 * Add an OpenRouter model as a GPTModel in Textual
 */
export async function addModelToTextual(
  token: string,
  modelId: string
): Promise<void> {
  await api.post(
    `${BASE_URL}add-to-textual`,
    { model_id: modelId },
    {
      headers: { token },
    }
  );
}
